import { MainAction } from './models'

export const postNewsLetter: MainAction<[string]> =
  (email: string) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })

    try {
      await api.post('/newsletter/subscribe', { email })
    } catch (err) {}
  }
